import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
export default function ReviewSection() {
  const scrollContainerRef = useRef(null);

  const handleScroll = (direction) => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const card = container.querySelector('[data-review-card]');
    if (!card) return;
    
    const cardWidth = card.offsetWidth;
    const gap = 24; 
    const scrollAmount = direction === 'left' ? -(cardWidth + gap) : (cardWidth + gap);

    container.scrollBy({
      left: scrollAmount,
      behavior: 'smooth',
    });
  };

  // Inline Style Objects
  const styles = {
    wrapper: {
      width:'100%',
      backgroundColor: '#fdf8f4',
      padding: '30px 20px',
      maxWidth: '1440px',
      margin: '0% auto',
      boxSizing: 'border-box',
    },
    mainHeading: {
      fontFamily: "'Poppins', sans-serif",
      fontWeight: 500,
      fontSize: '2.2rem',
      color: '#794d21',
      textAlign: 'center',
      marginBottom: '20px',
    },
    statsContainer: {
      display: 'flex',
      gap: '20px',
      justifyContent:'center',
    },
    statBox: {
      padding: '10px',
      position: 'relative',
    },
    statValue: {
      fontFamily: "'Poppins', sans-serif",
      fontWeight: 600,
      fontSize: '2rem',
      color: '#724213',
      margin: '0 0 4px 0',
    },
    statLabel: {
      fontFamily: "'Open Sans', sans-serif",
      fontSize: '0.9rem',
      color: '#555555',
      margin: 0,
    },
    sliderOuter: {
      width: '100%',
      overflow: 'hidden',
      marginBottom: '30px',
    },
    cardsScrollTrack: {
      display: 'flex',
      gap: '24px',
      overflowX: 'auto',
      scrollBehavior: 'smooth',
      WebkitOverflowScrolling: 'touch',
      padding: '20px 10px',
      msOverflowStyle: 'none',
      scrollbarWidth: 'none',
    },
    reviewCard: {
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      padding: '30px',
      boxShadow: '0 10px 30px rgba(114, 66, 19, 0.06)',
      display: 'flex',
      flexDirection: 'column',
      justifycontent: 'space-between',
      boxSizing: 'border-box',
      position: 'relative',
    },
    quoteIcon: {
      fontFamily: "'Poppins', sans-serif",
      fontSize: '4rem',
      color: '#ffdcb3',
      lineHeight: 1,
      position: 'absolute',
      top: '10px',
      left: '25px',
      opacity: 0.5,
      pointerEvents: 'none',
    },
    reviewText: {
      fontFamily: "'Open Sans', sans-serif",
      fontSize: '0.95rem',
      lineHeight: 1.6,
      color: '#2c2c2c',
      margin: '25px 0 30px 0',
      whiteSpace: 'pre-line',
    },
    profileContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
    },
    avatar: {
      width: '44px',
      height: '44px',
      borderRadius: '50%',
      objectFit: 'cover',
      border: '1.5px solid #ffdcb3',
    },
    profileMeta: {
      display: 'flex',
      flexDirection: 'column',
    },
    authorName: {
      fontFamily: "'Poppins', sans-serif",
      fontWeight: 600,
      fontSize: '0.95rem',
      color: '#222222',
      margin: 0,
    },
    reviewDate: {
      fontFamily: "'Open Sans', sans-serif",
      fontSize: '0.8rem',
      color: '#777777',
      marginTop: '2px',
    },
    navigationControls: {
      display: 'flex',
      justifyContent: 'center',
      gap: '16px',
      marginTop: '10px',
    },
    navButton: {
      backgroundColor: '#ffffff',
      border: '1px solid #e2deda',
      color: '#444444',
      width: '44px',
      height: '44px',
      borderRadius: '50%',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '1rem',
      boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
    },
  };

  return (
    <section style={styles.wrapper}>
      {/* Media queries to handle layout responsive columns on mobile, tablet, and desktop */}
      <style>{`
        [data-review-card] { flex: 0 0 100% !important; }
        
        @media (min-width: 600px) and (max-width: 1023px) {
          [data-review-card] { flex: 0 0 calc((100% - 24px) / 2) !important; }
        }
        
        @media (min-width: 1024px) {
          [data-review-track] { overflow-x: visible !important; justify-content: center !important; }
          [data-review-card] { flex: 0 1 calc((100% - 48px) / 3) !important; }
          [data-stat-box]:not(:last-child)::after {
            content: ''; position: absolute; right: 0; top: 15%; height: 70%; width: 1.5px; background-color: #bfa185; opacity: 0.6;
          }
        }
        [data-review-track]::-webkit-scrollbar { display: none; }
      `}</style>

      <h2 style={styles.mainHeading}>Give Review On</h2>

      {/* Manual Stats Row */}
      <div style={styles.statsContainer}>
        <Link to="https://www.tripadvisor.in/UserReviewEdit-g293890-d34195441-Himalayas_Travels-Kathmandu_Kathmandu_Valley_Bagmati_Zone_Central_Region.html" target="_blank"><img src="/img/company/google.png" alt=""className='googlebs' /></Link>
        <Link to="https://www.tripadvisor.in/UserReviewEdit-g293890-d34195441-Himalayas_Travels-Kathmandu_Kathmandu_Valley_Bagmati_Zone_Central_Region.html" target="_blank"><img src="/img/company/tripad.jpg" alt=""className='googlebs' /></Link>
        <Link to="https://www.tripadvisor.in/UserReviewEdit-g293890-d34195441-Himalayas_Travels-Kathmandu_Kathmandu_Valley_Bagmati_Zone_Central_Region.html" target="_blank"><img src="/img/company/trust.png" alt="" className='googlebs'/></Link>
      </div>

      {/* Manual Slider View */}
      <div style={styles.sliderOuter}>
        <div style={styles.cardsScrollTrack} ref={scrollContainerRef} data-review-track>
          
          {/* Card 1 */}
          <article style={styles.reviewCard} data-review-card>
            <span style={styles.quoteIcon}>“</span>
            <p style={styles.reviewText}>
             had a great private tour today with Bishnu at Swayambhunath Stupa in Kathmandu. What made the experience special was not only the place itself, but the way Bishnu guided the tour.

He is very knowledgeable, easy to talk to, and explains the history, culture and religious meaning in a very engaging and natural way. The tour never felt rushed or overly “touristic” — more like exploring the place with someone who genuinely loves and understands it.

              {"\n\n"}
              I especially appreciated how flexible and attentive he was throughout the tour, answering all my questions and sharing many interesting details I would never notice on my own.

Highly recommend Bishnu if you want a thoughtful and authentic experience in Kathmandu.
            </p>
            <div style={styles.profileContainer}>
              <img src="/img/company/airportdslr.jpeg" alt="Shreya Ghoshrawat" style={styles.avatar} />
              <div style={styles.profileMeta}>
                <h4 style={styles.authorName}>Alexander</h4>
                <time style={styles.reviewDate} dateTime="2026-01">May, 2026</time>
              </div>
            </div>
          </article>

          {/* Card 2 */}
          <article style={styles.reviewCard} data-review-card>
            <span style={styles.quoteIcon}>“</span>
            <p style={styles.reviewText}>
              Outstanding from start to finish. We opted for a tailored heritage and scenic tour, and the itinerary was brilliantly thought out—perfectly balancing the must-see UNESCO landmarks with some wonderful, hidden gems away from the main crowds. What sets Himalayas Travels apart is their immense hospitality; the team treated us like family rather than just clients. The pacing of the trip was spot-on, the value for money was exceptional, and their commitment to responsible tourism was brilliant to see. A massive thank you to our brilliant guide and driver. Will absolutely be booking our next holiday with them again!
            </p>
            <div style={styles.profileContainer}>
              <img src="/img/company/airportdslr.jpeg" alt="Pradeep R" style={styles.avatar} />
              <div style={styles.profileMeta}>
                <h4 style={styles.authorName}>David L</h4>
                <time style={styles.reviewDate} dateTime="2025-12">December, 2025</time>
              </div>
            </div>
          </article>

          {/* Card 3 */}
          <article style={styles.reviewCard} data-review-card>
            <span style={styles.quoteIcon}>“</span>
            <p style={styles.reviewText}>
            We booked our multi-day trek and cultural tour through Himalayas Travels, and it exceeded every expectation. From our initial inquiries, the communication was seamless and incredibly professional. Our guide was a wealth of knowledge, keeping us safe, motivated, and deeply connected to the local culture. They handled all the logistics—permits, internal transfers, and excellent tea house accommodations—with zero friction, which took all the stress out of the trip. If you are an American traveler looking for a flawless, deeply authentic, and bucket-list worthy Himalayan adventure, look no further. This team is top-tier!
            </p>
            <div style={styles.profileContainer}>
              <img src="/img/capital/myself.JPG" alt="Bharati D Patil" style={styles.avatar} />
              <div style={styles.profileMeta}>
                <h4 style={styles.authorName}>Sarah M</h4>
                <time style={styles.reviewDate} dateTime="2025-04">April 2025</time>
              </div>
            </div>
          </article>

        </div>
      </div>

      {/* Navigation Buttons */}
      <div style={styles.navigationControls}>
        <button onClick={() => handleScroll('left')} style={styles.navButton} aria-label="Previous reviews">&#10094;</button>
        <button onClick={() => handleScroll('right')} style={styles.navButton} aria-label="Next reviews">&#10095;</button>
      </div>
    </section>
  );
}